export const getFormErrors = (e) => {
    let errors = {};

    if (e.response && e.response.data && e.response.data.error) {
        const responseError = e.response.data.error;
        let errs, errText, fixedErrs;

        for (let field in responseError) {
            errs = Object.values(responseError[field]);
            fixedErrs = [];

            for (let f in errs) {
                errText = errs[f];

                if (typeof errText === "object") {
                    Object.keys(errText).map((key) => {
                        if (errText[key].slice(-1) !== ".") {
                            fixedErrs.push(errText[key] + ". ");
                        } else {
                            fixedErrs.push(errText[key] + " ");
                        }
                    });
                } else if (errText.slice(-1) !== ".") {
                    fixedErrs.push(errText + ". ");
                } else {
                    fixedErrs.push(errText);
                }
            }

            errors[field] = fixedErrs;
        }
    }

    return errors;
};

export const getFormArrayErrors = (e) => {
    let errors = {};

    if (e && e.response && e.response.data && e.response.data.error) {
        const responseError = e.response.data.error;

        let fErr;
        let arrErr;

        for (let field in responseError) {
            fErr = "";

            if (Array.isArray(responseError[field])) {
                arrErr = responseError[field];
                for (let i = 0; i < arrErr.length; i++) {
                    fErr += Object.values(arrErr[i])[0] + ", ";
                }
            } else {
                fErr = responseError[field];
                fErr = Object.values(fErr);
                fErr = fErr[0];
            }

            errors[field] = fErr;
        }
    }

    return errors;
};
